import { render, staticRenderFns } from "./JpReceOrderSelectDialog.vue?vue&type=template&id=2fe06045&scoped=true"
import script from "./JpReceOrderSelectDialog.vue?vue&type=script&lang=js"
export * from "./JpReceOrderSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe06045",
  null
  
)

export default component.exports